import * as React from 'react';
import * as intlEN from 'react-intl/locale-data/en';
import * as intlID from 'react-intl/locale-data/id';

import { Location } from 'history';
import { parse } from 'qs';
import { addLocaleData, IntlProvider } from 'react-intl';

import { DEFAULT_LOCALE } from 'constants/locale';
import { isSupportedLanguage } from 'helper/locale';

import { intlMessages } from 'locale/tool/mapper';
import 'locale/tool/polyfill';

import './LocaleProvider.scss';

interface LocaleProviderProps {
  location: Location;
}

export class LocaleProvider extends React.Component<LocaleProviderProps, {}> {
  constructor(props: LocaleProviderProps) {
    super(props);

    addLocaleData(intlEN);
    addLocaleData(intlID);
  }

  render() {
    const { lang } = parse(this.props.location.search.replace(/\?/g, ''));
    const supportedLang = isSupportedLanguage(lang) ? lang : DEFAULT_LOCALE;
    return (
      <IntlProvider locale={supportedLang} messages={intlMessages[supportedLang]}>
        {this.props.children}
      </IntlProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LocaleProvider/LocaleProvider.tsx